export default "__VITE_ASSET__DWLbBk7N__"